export abstract class BaseTreeService {
  abstract getCascadeChildren(): boolean;
  abstract setCascadeChildren(cascadeChildren: boolean): void;
}
